import gql from 'graphql-tag';

export const GET_TICKETS_PERIOD_FOLDER = gql`
  query getTasks($filter: GetTasksInput!, $pagination: PaginationInputType!) {
    getTasks(filter: $filter, pagination: $pagination) {
      tasks {
        status
        subject
        id
        createdAt
        payload {
          files {
            id
            name
          }
          transactions {
            amount
            currency
            note
            transactionDate
            transactionId
            transactionType
            counterpartyName
            counterpartyId
            counterparty {
              firstName
              lastName
              middleName

            }
            account {
              accountName
              iban
            }
          }
        }
      }
      total
    }
  }`;

export const GET_TICKET_MESSAGES = gql`
  query getMessages($chatId: String!, $limit: Float, $offset: Float) {
    getMessages(chatId: $chatId, limit: $limit, offset: $offset) {
      messages {
        taskId
        id
        payload {
          files {
            id
            sourceType
            size
            mimeType
            name
            createdAt
            updatedAt
          }
          periods {
            id
          }
        }
        messageText
        readAt
        createdAt
        updatedAt
        userSender {
          id
          email
          role
          isCompany
        }
      }
      total
    }
  }`;

export const ACCOUNTING_TICKET_TEMPLATES = gql`
  query accountingTicketTemplatesForAccountants {
    accounting {
      accountingTicketTemplatesForAccountants {
        id
        name
        subject
        message
      }
    }
  }`;
